const containerTransportContainerDetails = {
	"container.transport.container.containerDetails.eido": "PIN"
};

export { containerTransportContainerDetails }
